import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttachmentExportDialogComponent } from './attachment-export-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';




@NgModule({
  declarations: [AttachmentExportDialogComponent],
  imports: [
    CommonModule,
    FuseSharedModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatSlideToggleModule,
    TranslateModule
  ]
})
export class AttachmentExportDialogModule { }
